interface LoadingSkeletonProps {
  /** Number of bars to render. Default 3. */
  rows?: number;
  /** Optional className to size the container. */
  className?: string;
}

export function LoadingSkeleton({
  rows = 3,
  className,
}: LoadingSkeletonProps) {
  const widths = ['100%', '60%', '80%', '70%', '90%'];

  return (
    <div
      className={`flex flex-col gap-2 ${className ?? ''}`}
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="h-3.5 animate-pulse rounded bg-base-300"
          style={{ width: widths[i % widths.length] }}
        />
      ))}
    </div>
  );
}
